import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CallsAPI, HttpOptions } from './abstract/http/calls-api';
import { environment } from '../../../environments/environment';
import { CountryModel } from '../models/countryModel';

@Injectable({
  providedIn: 'root',
})
export class CountryHttpService extends CallsAPI<CountryModel, CountryModel[]> {
  protected apiBasePath: string = environment.api_url;
  protected resourcePath: string = '';
  /**
   * Default Options per Request
   * @protected
   * @type {HttpOptions}
   * @memberof HttpApiService
   */
  protected override defaultOptions: HttpOptions = {
    withCredentials: true,
  };

  /**
   * @param {HttpOptions} options
   * @returns
   * @memberof HttpApiService
   */
  public getCountryList(options?: HttpOptions): Observable<CountryModel[]> {
    return this.http.get<any>(
      this.buildAction('countries'),
      this.buildOptions(options)
    );
  }
}
